export const LOGIN = "/admin/login";
// export const GET_ALL_MY_FRIENDS = "/getAllMyFriends";
export const LIST_ALL_USERS = "/admin/users";
export const BLOCK_USER_API = (userId) => `/admin/users/${userId}/status`;

export const MEMOIRS_DOWNLOAD = (id) => `/admin/memoirs/${id}/download`;
export const BIOGRAPHY_DOWNLOAD = (id) => `/admin/biographies/${id}/download`;
export const ADMIN_MEMOIRS = "/admin/memoirs";
export const ADMIN_BIOGRAPHIES = "/admin/biographies";
export const DASHBOARD = '/admin/dashboard';
export const LOGOTUT = '/admin/logout';
export const GET_SUBSCRIPTION_USERS = '/admin/subscriptions';
// export const USER_SUBSCRIPTION_LIST = '/listUsersWithSubscription'


